import { formatDimensions } from "@/data/artworks";

export const ArtworkMeta = ({ artwork, className = "" }) => (
  <div className={`text-[15px] leading-[1.8] text-[#2F2C28] ${className}`}>
    {artwork.medium && <p>{artwork.medium}</p>}
    <p>{formatDimensions(artwork)}</p>
    <p>Original artwork · One of one</p>
  </div>
);
